'use client'

import { ThemeProvider } from "next-themes";
import { useState, useEffect } from "react";

function LayoutWrapper({ children }: { children: React.ReactNode }) {
    return (
        <div className="flex flex-col min-h-dvh overflow-y-scroll scrollbar-hide [scrollbar-width:none] [-ms-overflow-style:none]">
            {children}
        </div>
    );
}

export function Providers({ children }: { children: React.ReactNode }) {
    const [forcedTheme, setForcedTheme] = useState<string | undefined>(undefined);
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        setForcedTheme(mediaQuery.matches ? "dark" : undefined);

        // Opcional: atualizar se o sistema mudar
        const handler = (e: MediaQueryListEvent) => {
            setForcedTheme(e.matches ? "dark" : undefined);
        };
        mediaQuery.addEventListener('change', handler);
        return () => mediaQuery.removeEventListener('change', handler);
    }, []);

    // Renderiza placeholder ou children sem theme até montar
    if (!mounted) {
        return (
            <div className="flex flex-col min-h-dvh">
                {children}
            </div>
        );
    }

    return (
        <ThemeProvider
            attribute="class"
            storageKey="theme-preference"
            enableSystem={true}
            forcedTheme={forcedTheme}
        >
            <LayoutWrapper>
                {children}
            </LayoutWrapper>
        </ThemeProvider>
    );
}